(ns motorsaif.web.pages.public-profile
  (:require
   [reagent.core :as r]
   [motorsaif.utils :as utils]
   [motorsaif.time :as time]
   [motorsaif.string :refer [format]]
   [motorsaif.web.components :as c]
   ["react" :as react]
   [re-frame.core :as rf :refer [subscribe]]))

;; https://dribbble.com/shots/6642155-Dropbox-Desktop-Redesign-Web-Dashboard-Product-Design
;; https://dribbble.com/shots/5912520-Payments-alerts
;; https://moderncss.dev/pure-css-custom-styled-radio-buttons/
;; https://dribbble.com/shots/12063074-Daily-UI-Challenge-001-Sign-Up
;; https://dribbble.com/shots/16444176-Create-Edit-trip-page-Travel-manager  side bar



(defn back-icon []
  [:svg {:class "back-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"}]])

(defn share-icon []
  [:svg {:width "14" :height "14" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"}]])

(defn more-icon []
  [:svg {:width "14" :height "14" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"}]])

(defn verified-icon []
  [:svg {:class "verified-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"}]])

(defn payment-icon []
  [:svg {:class "payment-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M2 17h20v2H2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.48L4.85 6.95 4 8.43 3.15 6.95 2.45 7.7l.85 1.48H1v1.5h2.3l-.85 1.48.7.77L4 10.53l.85 1.48.7-.77-.85-1.48H6.7l.85 1.48.7-.77L7.4 9.76 8.25 8.28l-.7-.77L6.7 8.99H5.15l.85-1.48-.7-.77-.85 1.48H2v1.5h2.3l-.85 1.48.7.77L4.85 9.5 4 11.47h18v7H2z"}]])

(defn repair-icon []
  [:svg {:class "category-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"}]])

(defn parts-icon []
  [:svg {:class "category-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M13 10V3L4 14h7v7l9-11h-7z"}]])

(defn performance-icon []
  [:svg {:class "category-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"}]
   [:path {:d "M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"}]])

(defn expand-icon []
  [:svg {:class "expand-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M19 9l-7 7-7-7"}]])

(defn chat-icon []
  [:svg {:class "btn-icon" :fill "currentColor" :viewBox "0 0 24 24"}
   [:path {:d "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"}]])





(defn stat-item [number label]
  [:div.stat-item
   [:div.stat-number number]
   [:div.stat-label label]])

(defn service-item [text]
  [:li.service-item text])

(defn service-category [icon title items]
  [:div.service-category
   [:div.category-header
    [:div.category-title
     [:div.category-icon-wrapper
      icon
      title]
     #_[expand-icon]]]
   [:div.category-content
    [:ul.service-list
     (for [item items]
       ^{:key item} [service-item item])]]])

(defn motorsaif-profile [profile]
  [:div
   ;; Header Section
   [:div.header
    [:div.nav-bar
     [:button.btn.back-btn
      {:on-click
       #(.back js/window.history)}
      [:i.fa-regular.fa-chevron-left] "Back"]

     #_[:div.header-actions
        [:button.action-btn
         [share-icon]]
        [:button.action-btn
         [more-icon]]]]

    [:div.company-info
     [:div.company-avatar
      [c/avatar-letter profile {}]]
     [:div.company-details
      [:h1 "MotorSaif"]
      [:div.status-row
       [:div.official-badge
        [verified-icon]
        "Official"]
       [:span.response-time
        (format "Last seen %s" (time/tr-ago-str @(subscribe [:user-last-seen (:db/id profile)])))]]]]

    [:div.header-accent]]

   ;; Content Section
   [:div.content

    ;; Overview Section
    [:div.overview-section
     [:div.overview-stats
      ;; [stat-item "53" "requests fulfilled"]
      ;; [stat-item "4.9" "Rating"]
      ]

     [:p.company-description
      "Professional automotive services across the UAE. Specializing in vehicle repairs, genuine parts sourcing, and performance modifications with transparent pricing and reliable service delivery."]

     [:div.payment-methods
      [payment-icon]
      [:span.payment-text "Cash & Bank Transfer Accepted"]]]

    ;; Services Section
    [:div.services-section
     [:div.section-header
      [:h2.section-title "Our Services"]]

     [service-category
      [repair-icon]
      "Vehicle Repairs"
      ["Complete pickup and delivery service eliminating garage visits"
       "Comprehensive follow-up and post-repair inspection"]]

     [service-category
      [parts-icon]
      "Parts & Components"
      ["Genuine and aftermarket parts for all vehicle makes"
       "UAE-wide delivery network"
       "Return policy dependent on vendor specifications"]]

     [service-category
      [performance-icon]
      "Performance & Modifications"
      ["Professional engine tuning and optimization"
       "Premium infotainment and audio system installations"
       "Advanced security and camera system integration"]]]]

   ;; CTA Section
   [:div.cta-section
    [:h3.cta-title "Get Your Quote"]
    [:p.cta-subtitle "Repair estimates are non binding and vehicle may require more work than initially diagnosed"]
    [:div.cta-buttons
     #_[:button.secondary-btn "View Portfolio"]]]])

;; Usage example - drop this baby into your app!












(defn sect [title content]
  [:section
   [:h4 title]
   [:p content]])


;; Shamelessly copied from form
(def biz-types [{:title "Repair Garage"
                 :id :repair-garage}
                {:title "Modification Garage"
                 :id :mod-garage}
                {:title "New Parts"
                 :id :new-parts}
                {:title "Used Parts"
                 :id :used-parts}])

;; TODO leaks roles
(defn root []

  (let [{:keys [id]} @(subscribe [:route/parameters])
        *profile (subscribe [:public-profile id])
        {:business/keys [coords description name location misc media]} @*profile
        [lon lat] coords
        {biz-type :type
         hours :hours
         car-types :car-types} misc
        {loc-name :location/name} location
        official? (utils/official-account? @*profile)
        ]
    [:div.root-wrap
     #_[c/header-with-back
        [:div name]
        {:subtitle
         [:span
          (if official?
            "Official"
            (or (:title (first (filter #(= (:id %) biz-type) biz-types)))
                "Business"))]}]
     (if official?
       [motorsaif-profile @*profile]
       #_[:div.container.sm
          [:p "This is the official MotorSaif team here to help you with your car needs.
A rough quotation and timeline will be provided for repairs, and a precise quotation for car parts.
We currently accept cash and bank transfer.
"]
          [:h2 "Repairs"]
          [:p
           [:ul
            [:li
             "End to end pickup and delivery of your vehicle, eliminating the entire hassle of dealing with any garages."]
            [:li
             "We handle the the follow up and post inspection following the repair before handing your car back to you."]]]
          [:h2 "Parts"]
          [:ul
           [:li "We will locate whatever part you need for your car."]
           [:li "Delivery of parts all over UAE."]
           [:li "Return policy varies by part and vendor."]]
          [:h2 "Upgrades and Modifications."]
          [:ul
           [:li "Performance tuning."]
           [:li "Infotainment."]
           [:li "Camera installation."]
           ]

          ]
       [:div.container.sm
        (when media
          [c/mobile-photos {:media media}])
        [sect "About" description]
        [sect "Opening Hours" hours]
        [:section
         [:h4 "Location"]
         [:p loc-name]
         ;; https://developers.google.com/maps/documentation/urls/get-started
         ;;
         [:div.map-link
          [:a
           {:href (format " https://www.google.com/maps/search/?api=1&query=%s&zoom=8"
                          (format "%s,%s" lat lon))
            :target "_blank"}
           "Open in google maps"]]

         #_[:a.directions
            {:href (format " https://www.google.com/maps/dir/?api=1&destination=%s"
                           (format "%s,%s" lat lon))}
            "Open in google maps"]]
        [c/map-image coords]
        #_[:img#map {:src
                     (format "https://maps.googleapis.com/maps/api/staticmap?center=%s&zoom=12&size=600x600&key=%s&markers=%s"
                             (format "%s,%s" lat lon)
                             js/mapsKey
                             (format "%s,%s" lat lon))}]

        #_[google-map lon lat]])
     ;; (str coords)
     ]))
